import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import classNames from 'classnames';

import {
  FeatureToggleWrapContainer,
} from '../../containers/FeatureToggleWrapContainer/FeatureToggleWrapContainer';
import {
  StoreSwitcherButtonContainer,
} from '../../containers/StoreSwitcherButtonContainer/StoreSwitcherButtonContainer';
import { storeSwitcherHooks } from '../../hooks/storeSwitcherHooks/storeSwitcherHooks';
import { FeatureToggleValues } from '../../types/FeatureToggles';
import { DropDownMenuPresentational } from '../../types/common';
import {
  FooterLinksSection,
} from '../FooterLinksSection/FooterLinksSection';
import { Typography, TypographyColor } from '../Typography/Typography';
import styles from './FooterMiddlePart.module.css';

export type Props = {
  data?: DropDownMenuPresentational[];
};

export const messages = defineMessages({
  text: {
    id: 'src.components.FooterMiddlePart.text',
    defaultMessage: 'Land en taal',
  },
});

export const FooterMiddlePart: React.FC<Props> = React.memo(({ data }) => {
  const storeSwitcherButtonLabel = storeSwitcherHooks.useGetStoreSwitcherButtonLabel({
    isNonBlockPart: true,
  });

  return data ? (
    <section className={styles.wrapper}>
      <div className={styles.footerMiddlePart}>
        {
          data?.map((menuItem, idx) => {
            const lastColumn = idx === data.length - 1;
            return (
              <div
                className={styles.sectionWrapper}
                key={`section_wrapper_${menuItem.title}`}
              >
                <FooterLinksSection
                  className={classNames({ [styles.lastColumn]: lastColumn })}
                  {...menuItem}
                />
                {lastColumn && (
                  <FeatureToggleWrapContainer>
                    {({ languageSwitcher }: FeatureToggleValues) => (
                      <>
                        {languageSwitcher ? (
                          <>
                            <Typography
                              variant='body2'
                              className={styles.text}
                              color={TypographyColor.Tertiary}
                            >
                              <FormattedMessage {...messages.text} />
                            </Typography>
                            <StoreSwitcherButtonContainer
                              className={styles.storeSwitcherButton}
                              textClassName={styles.textClassName}
                              iconFill='var(--white)'
                              label={storeSwitcherButtonLabel}
                              isNonBlockPart
                            />
                          </>
                        ) : null}
                      </>
                    )}
                  </FeatureToggleWrapContainer>
                )}
              </div>
            );
          })
        }
      </div>
    </section>
  ) : null;});

FooterMiddlePart.displayName = 'FooterMiddlePart';
